import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import { MemoryRouter, Route } from "react-router";
import Pagination from "@material-ui/lab/Pagination";
import PaginationItem from "@material-ui/lab/PaginationItem";
import Breadcrumb from "../../components/breadcrumb/breadcrumb";
import ContentLoader from "react-content-loader";
import { generatePath } from "react-router";

import * as dropdowns from "../product/Dropdown";
import "./subcategory.css";
import {
  childCategories,
  subCategories,
  getProducts,
  getSubCategoryBySlug,
  getGroups,
} from "../../actions/categories";
import { getProductsByCategoryId } from "../../actions/products";
import { cartAdd } from "../../actions/cart";
import { Button, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StarRatings from "react-star-ratings";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

import {
  CarouselProvider,
  DotGroup,
  ImageWithZoom,
  Slide,
  Slider,
} from "pure-react-carousel";
import { getFilteredProduct } from "../../actions/filter";
import "pure-react-carousel/dist/react-carousel.es.css";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import SingleProduct from "../../components/singleProductCard/singleProductCard";

// sidebar
import { Drawer } from "@material-ui/core";

const CheckboxDiv = (props) => {
  return (
    <>
      <li>
        <div className="w-100 side-inner-inputs align-center" id="recom">
          <input id={props.id} type="checkbox" />
          <label
            className="lableHovered d-block  w-100 c-pointer mb-0 ml-3"
            for={props.id}
          >
            {props.lableText}
          </label>
        </div>
      </li>
    </>
  );
};

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterDrawer: false,
      link: "",
      parentModel: "",
      loading: true,
      dataPerPage: 20,
      currentPage: 1,
      subCategory: null,
      childCategory: null,
      products: [],
      filterProducts: [],
      show: false,
      quickView: [],
      images: [],
      testIndex: null,
      setTitle: "",
      quantity: 1,
      affirm: [],
      colorFilter: [],
      priceFilter: [],
      heightFilter: [],
      widthFilter: [],
      color: "",
      width: 0,
      price: 0,
      height: 0,
      rightSidebar: false,
      groupFilters: [],
      subTitle: "test",
      selectedButton: [],
      havBoxShadow: false,
      changeId: "",
      indexes: [],
      contForm: false,
      checkId: "",
      configuration: [],
      groupCallFlag: false,
      catagoryConfigurationDetails: [],
      groupLoading: true,
      configAttrId: [],
      selectedFilters: [],
      queryString: "",
      attrSelectedArr: [],
      count: 0,
      categoryId: "",
      finalFilters: [],
      filterPageFlag: true,
    };
    this.flagStateUpdater = this.flagStateUpdater.bind(this);

    this.showContactForm = () => {
      this.setState({
        contForm: true,
      });
    };
  }

  async componentDidMount() {
    console.log(this.props.location.search);
    this.setState({ currentPage: this.props.match.params.page });
    const page = this.state.currentPage;
    const slug = this.props.match.params.slug;
    await this.fetchData(slug, this.props.match.params.page);

    if (this.props.location.search) {
      let testerString = this.props.location.search.substring(1);

      let testerString1 = testerString.replaceAll("%20", " ");

      let testerArray = testerString1.split("&");

      this.setState({
        selectedFilters: testerArray,
      });

      let attrArray = [];
      this.state.groupFilters.map((item) => {
        item.filters.map((item1) => {
          this.state.selectedFilters.map((item2) => {
            if (item1.title === item2) {
              attrArray.push(item1.selectedAttribute);
            }
          });
        });
      });
      this.setState({ attrSelectedArr: attrArray });
      const dataToSend = {
        slug: this.props.match.params.slug,
        filter: this.state.attrSelectedArr,
      };
      const Res = await this.props.getFilteredProduct(
        JSON.stringify(dataToSend)
      );
      this.setState({
        filterProducts: Res[0].products[0].paginatedResults,
      });
      this.setState({
        count: Res[0].products[0].totalCount[0].count,
      });
      const currentState = await this.flagStateUpdater();
    }

    this.setState({
      configuration: this.state.subCategory.configuration[0],
    });
    if (this.state.configuration) {
      this.setState({
        catagoryConfigurationDetails: this.state.configuration
          .categoryConfiguration[0].categoryConfigurationDetail,
      });
    }
    const test = await this.flagStateUpdater();

    window.scrollTo(0, 0);
  }

  async componentWillReceiveProps() {
    console.log(window.location.toString().split("/products/"));
    const slug = window.location
      .toString()
      .split("/products/")[1]
      .split("/")[0];
    await this.fetchData(slug, 1);
    this.setState({
      configuration: this.state.subCategory.configuration[0],
    });
    if (this.state.configuration) {
      this.setState({
        catagoryConfigurationDetails: this.state.configuration
          .categoryConfiguration[0].categoryConfigurationDetail,
      });
    }
    console.log(this.state.filterProducts);
    if (!this.state.loading) {
      this.setState({ groupCallFlag: false }, async () => {
        const finalTester = await this.flagStateUpdater();
        console.log(finalTester);
      });
    }
    if (
      this.props.match.params.slug !== window.location.toString().split("y/")[1]
    ) {
      window.scrollTo(0, 0);
      if (this.props.history.action === "POP") {
        this.props.history.goBack();
      }
    }
  }

  fetchData = async (slug, page) => {
    this.setState({ loading: true });

    const subCategories = await this.props.getSubCategoryBySlug(slug, page);

    const productsArr = subCategories.data[0].products[0].paginatedResults;

    this.setState({ products: productsArr });

    this.setState({ subCategory: subCategories.data[0] });
    this.setState({ categoryId: subCategories.data[0]._id });
    this.setState({
      count: this.state.subCategory.products[0].totalPages,
    });

    this.setState({ groupFilters: subCategories.data[0].groupFilters });
    if (this.state.groupFilters) {
      const tempFiltersFinal = [];

      this.state.groupFilters.map((item, index) => {
        const tempFilters = [];

        if (item.filters.length) {
          item.filters.map((item1) => {
            item1.category.map((item2) => {
              if (this.state.categoryId === item2.categoryId) {
                if (item2.image) {
                  tempFilters.push({
                    title: item1.title,
                    image: item2.image,
                    imageFlag: true,
                  });
                } else {
                  tempFilters.push({
                    title: item1.title,
                    imageFlag: false,
                  });
                }
              }
            });
          });
          tempFiltersFinal.push({
            title: item.title,
            children: tempFilters,
          });
        }
      });
      const tempFiltersFinalFinal = [];
      tempFiltersFinal.map((item) => {
        const imageFilters = [];
        const nonImageFilters = [];
        item.children.map((item1) => {
          if (item1.imageFlag) {
            imageFilters.push(item1);
          } else {
            nonImageFilters.push(item1);
          }
        });
        tempFiltersFinalFinal.push({
          title: item.title,
          children: {
            imageFilters,
            nonImageFilters,
          },
        });
      });

      this.setState({ finalFilters: tempFiltersFinalFinal });
    }

    this.setState({ childCategory: subCategories.data[0].categories[0] });
    this.setState({ filterProducts: productsArr });
    this.setState({ loading: false });
  };

  _getUnique = async (array) => {
    var seen = {};
    var check = array.filter(function (item) {
      return seen.hasOwnProperty(item) ? false : (seen[item] = true);
    });
    return check;
  };
  componentDidUpdate(nextState, prevState, nextProps) {
    if (prevState.currentPage !== this.state.currentPage) {
      this.props.match.params.page = this.state.currentPage;
    }
  }

  filterBorderHandler = (index, item1) => {
    console.log(item1.title);
    const testData = [...this.state.selectedButton];

    if (index === testData[index]) {
      testData[index] = "";
      this.setState({ selectedButton: testData });
    } else {
      testData[index] = index;

      this.setState({ selectedButton: testData });
    }
  };

  // addBoxShadow = (item, index, testId) => {
  //   if (index != "undefined") {
  //     this.setState({
  //       havBoxShadow: !this.state.havBoxShadow,
  //       testIndex: index,
  //       changeId: testId,
  //     });
  //   }
  // };

  handleSelectedFilters = (event, SelectedFilter) => {
    this.setState(
      {
        selectedFilters: SelectedFilter,
      },
      function () {
        let attrArray = [];
        this.state.groupFilters.map((item) => {
          item.filters.map((item1) => {
            this.state.selectedFilters.map((item2) => {
              if (item1.title === item2) {
                attrArray.push(item1.selectedAttribute);
              }
            });
          });
        });
        this.setState({ attrSelectedArr: attrArray }, function () {
          this.setState(
            {
              queryString: this.state.selectedFilters.join("&"),
            },
            async function () {
              this.props.history.push({
                search: `${this.state.queryString}`,
              });
              const dataToSend = {
                slug: this.props.match.params.slug,
                filter: this.state.attrSelectedArr,
              };
              this.setState({ loading: true });
              this.setState({ groupCallFlag: false });
              if (this.state.attrSelectedArr.length !== 0) {
                const Res = await this.props.getFilteredProduct(
                  JSON.stringify(dataToSend)
                );
                this.setState(
                  {
                    filterProducts: Res[0].products[0].paginatedResults,
                  },
                  async function () {
                    this.setState({
                      count: Res[0].products[0].totalCount[0].count,
                    });
                    const currentState = await this.flagStateUpdater();
                    this.setState({ loading: false });
                  }
                );
              }
            }
          );
        });
      }
    );
  };

  flagStateUpdater = async () => {
    const idArr = [];
    console.log(this.state.filterProducts);
    this.state.filterProducts.map((item) => {
      if (item.groupedItem) {
        idArr.push(item._id);
      }
    });

    if (this.state.groupCallFlag === false) {
      const configattrr = [];
      if (this.state.subCategory.configuration[0]) {
        this.state.subCategory.configuration[0].categoryConfiguration[0].categoryConfigurationDetail.map(
          (item) => configattrr.push(item.keyFieldId)
        );
      }

      this.setState({ groupCallFlag: true });

      const dataTosend = {
        ids: idArr,
        attributes: configattrr,
      };
      const Res = await this.props.getGroups(JSON.stringify(dataTosend));

      const newData = this.state.filterProducts;

      if (Res.data.data !== 0 && Res.data.length !== 0) {
        this.state.filterProducts.map((item, index) => {
          Res.data.map((item1) => {
            if (item._id === item1._id) {
              newData[index] = {
                ...item,
                grouping: item1.grouping,
                count: item1.count,
              };
            }
          });
        });
      }

      this.setState({ filterProducts: newData });
      this.setState({ groupLoading: false });
      return Res;
    }
  };

  _addToWishlist = async (item) => {
    const wishlistData = localStorage.getItem("wishlist");
    if (wishlistData && wishlistData.length > 0) {
      const arr = JSON.parse(wishlistData);
      var a = true;
      arr.forEach((e, index) => {
        if (e._id === item._id) {
          a = false;
          arr.splice(index, 1);
          toast(`Product removed from wishlist`, { containerId: "C" });
        }
      });
      if (a === true) {
        arr.push(item);
      }
      localStorage.setItem("wishlist", JSON.stringify(arr));
    } else {
      localStorage.setItem("wishlist", JSON.stringify([item]));
    }
    if (a !== false) {
      this.setState({ show: false });
      toast(`Product added to wishlist`, { containerId: "C" });
    }
  };
  toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.type === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ rightSidebar: open });
  };

  productsLoader = (number) => {
    let table = [];

    for (let i = 0; i < number; i++) {
      table.push(
        <Fragment>
          {
            <ContentLoader
              speed={2}
              width={300}
              height={470}
              viewBox="0 0 300 470"
              backgroundColor="#f3f3f3"
              foregroundColor="#ecebeb"
              className="col-md-3"
            >
              <rect x="4" y="35" rx="0" ry="0" width="291" height="256" />
              <rect x="4" y="309" rx="0" ry="0" width="276" height="52" />
              <rect x="4" y="372" rx="0" ry="0" width="104" height="27" />
              <rect x="7" y="445" rx="0" ry="0" width="142" height="20" />
              <circle cx="19" cy="421" r="14" />
              <circle cx="152" cy="422" r="14" />
              <circle cx="53" cy="421" r="14" />
              <circle cx="88" cy="422" r="14" />
              <circle cx="121" cy="421" r="14" />
            </ContentLoader>
          }
        </Fragment>
      );
    }
    return table;
  };
  _addToCart = async (item) => {
    const data = {
      item: item,
      quantity: this.state.quantity,
    };
    const cartAdd = await this.props.cartAdd(data);
    if (cartAdd) {
      this.setState({
        show: false,
        quantity: 1,
      });
      toast(`Product added in cart`, { containerId: "C" });
    }
  };
  handleClose = () => {
    this.setState({ show: false, quantity: 1 });
  };
  handleShow = () => {
    this.setState({ show: true, quantity: 1 });
  };
  _openModal = async (e, item) => {
    e.preventDefault();
    this.setState({ quickView: item });
    const images = [];
    item.images.forEach((e) => {
      images.push({
        original: e,
        thumbnail: e,
      });
    });
    this.setState({ images: images });

    this.setState({ show: true });
  };

  handleClick = async (event) => {
    console.log(this.state.attrSelectedArr);
    this.setState(
      {
        currentPage: Number(event.page),
      },
      async () => {
        if (this.props.location.search.length !== 0) {
          if (this.state.filterPageFlag) {
            this.setState({
              currentPage: 1,
              filterPageFlag: false,
            });
          }
          this.props.history.push({
            pathname: generatePath(this.props.match.path, {
              slug: this.props.match.params.slug,
              page: this.state.currentPage,
            }),
          });
          this.props.history.push({
            search: `${this.state.queryString}`,
          });
          const dataToSend = {
            slug: this.props.match.params.slug,
            filter: this.state.attrSelectedArr,
            page: this.state.currentPage,
          };
          this.setState({ loading: true });
          this.setState({ groupCallFlag: false });

          const Res = await this.props.getFilteredProduct(
            JSON.stringify(dataToSend)
          );
          const test = await this.flagStateUpdater();

          this.setState({
            configuration: this.state.subCategory.configuration[0],
          });
          if (this.state.configuration) {
            this.setState({
              catagoryConfigurationDetails: this.state.configuration
                .categoryConfiguration[0].categoryConfigurationDetail,
            });
          }

          this.setState({ loading: false });
        } else {
          this.props.history.push({
            pathname: generatePath(this.props.match.path, {
              slug: this.props.match.params.slug,
              page: this.state.currentPage,
            }),
          });

          const slug = this.props.match.params.slug;
          this.setState({ groupCallFlag: false });

          await this.fetchData(slug, this.state.currentPage);
          const test = await this.flagStateUpdater();

          this.setState({
            configuration: this.state.subCategory.configuration[0],
          });
          if (this.state.configuration) {
            this.setState({
              catagoryConfigurationDetails: this.state.configuration
                .categoryConfiguration[0].categoryConfigurationDetail,
            });
          }

          this.setState({ loading: false });
        }
      }
    );
  };

  render() {
    const {
      quickView,
      loading,
      configuration,
      catagoryConfigurationDetails,
    } = this.state;

    const { filterProducts, products, currentPage, dataPerPage } = this.state;

    // Logic for displaying todos
    const indexOfLastTodo = currentPage * dataPerPage;
    const indexOfFirstTodo = indexOfLastTodo - dataPerPage;
    const currentTodos =
      filterProducts && filterProducts.slice(indexOfFirstTodo, indexOfLastTodo);

    // Logic for displaying page numbers
    const pageNumbers = [];
    for (
      let i = 1;
      i <= Math.ceil(filterProducts && filterProducts.length / dataPerPage);
      i++
    ) {
      pageNumbers.push(i);
    }

    // const renderPageNumbers = pageNumbers.map((number) => {
    //   return (
    //     <ul style={{ display: "inline-block" }}>
    //       <li
    //         className={number === this.state.currentPage ? "active" : ""}
    //         key={number}
    //         id={number}
    //         style={{ listStyle: "none" }}
    //       >
    //         {/* {number === this.state.currentPage ? ( */}
    //         <button
    //           id={number}
    //           className="btn btn-primary pagi-button"
    //           onClick={this.handleClick}
    //         >
    //           {number}
    //         </button>
    //       </li>
    //     </ul>
    //   );
    // });

    return (
      <Fragment>
        {/* PRODUCTS BODY */}

        <div className="products-page wrapper-90 max-1600">
          <ToastContainer
            enableMultiContainer
            containerId={"B"}
            position={toast.POSITION.TOP_RIGHT}
          />
          {this.state.subCategory && this.state.subCategory !== null && (
            <Breadcrumb
              title={`${
                this.state.childCategory &&
                this.state.childCategory !== null &&
                this.state.childCategory.name
              } / ${
                this.state.subCategory &&
                this.state.subCategory !== null &&
                this.state.subCategory.name
              }`}
            />
          )}

          <div className="product-heading">
            <h2>{this.state.subCategory && this.state.subCategory.name}</h2>
          </div>
          {this.state.groupFilters && this.state.groupFilters.length > 0 ? (
            <div className="products-dropdown-links">
              <ul className="products-dropdown-list">
                {/* PILE HEIGHT DROPDOWN */}
                {this.state.finalFilters.map((item) => (
                  <li className="p-2 dropdown-titles">
                    <span className="p-2">{item.title}</span>
                    <i className="fa fa-angle-down" />

                    <ul className="products-dropdown-innerlist">
                      <div className="">
                        <div className=" d-flex">
                          {item.children &&
                            item.children.imageFilters.map((item1, index) => (
                              <li
                                className="design-selection-item m-0"
                                key={index}
                              >
                                <div
                                  className=" text-center select-to-filter-item"
                                  id={this.state.changeId}
                                >
                                  <ToggleButtonGroup
                                    value={this.state.selectedFilters}
                                    onChange={this.handleSelectedFilters}
                                  >
                                    <ToggleButton
                                      value={`${item1.title}`}
                                      aria-label={`${item1.title}`}
                                    >
                                      <img
                                        src={item1.image}
                                        className="img-fluid w-100"
                                        alt=""
                                      />

                                      <p>{item1.title}</p>
                                    </ToggleButton>
                                  </ToggleButtonGroup>
                                </div>
                              </li>
                            ))}
                        </div>
                      </div>
                      {item.children &&
                        item.children.nonImageFilters.map((item1, index) => (
                          <li key={index}>
                            <ToggleButtonGroup
                              value={this.state.selectedFilters}
                              onChange={this.handleSelectedFilters}
                            >
                              <ToggleButton
                                value={`${item1.title}`}
                                aria-label={`${item1.title}`}
                                className="w-100"
                              >
                                <div className="d-flex align-items-center flex-row-reverse w-100">
                                  <label
                                    className="inputLable-hovered f1 m-0 w-100 c-pointer"
                                    htmlFor={`filterSelect${item.title}${index}`}
                                  >
                                    <p>{item1.title}</p>
                                  </label>
                                  <div className="p-2 filter-input">
                                    <input
                                      type="checkbox"
                                      id={`filterSelect${item.title}${index}`}
                                    />
                                  </div>
                                </div>
                              </ToggleButton>
                            </ToggleButtonGroup>
                          </li>
                        ))}
                    </ul>
                  </li>
                ))}

                {/*END PILE HEIGHT DROPDOWN */}
                {/* PRICE PER PRODUCT DROPDOWN */}

                {/*END PRICE PER PRODUCT DROPDOWN */}
                {/*RUG SHAPE DROPDOWN */}

                <li
                  className="dropdown-titles call-us-btn"
                  style={{ width: "150px", textAlign: "center" }}
                  onClick={() =>
                    this.setState({ filterProducts: this.state.products })
                  }
                >
                  Clear Filter
                </li>

                <li
                  className="sort-filter-btn d-flex align-items-center p-2"
                  onClick={this.toggleDrawer("anchor", true)}
                >
                  <span>Sort & Filter</span>
                </li>

                <Drawer
                  anchor={"right"}
                  open={this.state.rightSidebar}
                  onClose={this.toggleDrawer("right", false)}
                >
                  <div className="productFilterSidebar">
                    <div className="sidebar-header">
                      <div
                        title="close"
                        className="closeSidebar"
                        onClick={this.toggleDrawer("right", false)}
                      >
                        <button type="button" className="close-sidebar-btn">
                          <svg
                            focusable="false"
                            viewBox="0 0 28 28"
                            class="closeSide-icon"
                            aria-hidden="true"
                            data-hb-id="pl-icon"
                          >
                            <path d="M15.4 14l3.3-3.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0L14 12.6l-3.3-3.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3.3 3.3-3.3 3.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3l3.3-3.3 3.3 3.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L15.4 14z"></path>
                          </svg>
                        </button>
                      </div>
                      <div className="sidebar-header-text">
                        <span>Sort & Filtre</span>
                      </div>
                    </div>
                    <div className="sidebarBody-inner">
                      <dropdowns.Dropdown
                        dropdownLable="Weights & Dimensions"
                        dropdownSubtitle={this.state.subTitle}
                      >
                        <div className="filter-dropDown-body">
                          Lorem ipsum dolor sit, amet consectetur adipisicing
                          elit. Facere nobis officiis odio!
                        </div>
                      </dropdowns.Dropdown>
                    </div>
                  </div>
                </Drawer>

                {/*END Rug Shape DROPDOWN  */}
              </ul>
            </div>
          ) : null}
          <div className="products-body">
            <div className="container-fluid px-0">
              <div className="products-items">
                {/* FIRST ROW */}
                {filterProducts && filterProducts === 0 ? (
                  <h5>No Product Found</h5>
                ) : null}
                {loading ? (
                  this.productsLoader(16)
                ) : (
                  <div className="row">
                    {this.state.filterProducts &&
                      this.state.filterProducts.map((item) => (
                        <SingleProduct
                          item={item}
                          groupLoading={this.state.groupLoading}
                          loading={this.state.loading}
                          configuration={this.state.configuration}
                          catagoryConfigurationDetails={
                            this.state.catagoryConfigurationDetails
                          }
                          slug={this.props.match.params.slug}
                        />
                      ))}
                  </div>
                )}

                <div className="container text-center">
                  <MemoryRouter initialEntries={["/inbox"]} initialIndex={0}>
                    <Route>
                      {({ location }) => {
                        return (
                          <Pagination
                            page={
                              this.state.currentPage && this.state.currentPage
                            }
                            count={this.state.count}
                            renderItem={(item) => (
                              <PaginationItem
                                {...item}
                                onClick={(e) => this.handleClick(item)}
                              />
                            )}
                          />
                        );
                      }}
                    </Route>
                  </MemoryRouter>{" "}
                </div>
              </div>
              {/*product item*/}
            </div>
            {/*Container fluid*/}
          </div>
          {/*product body*/}
        </div>

        {/*products-page*/}

        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          animation={false}
          style={{ marginTop: "2%", boxShadow: "none" }}
        >
          <Modal.Body>
            {this.state.show && this.state.show === true && quickView ? (
              <div className="container-fluid">
                <div className="row">
                  <div
                    className="modal-close"
                    onClick={this.handleClose}
                    data-dismiss="modal"
                  >
                    <span closeButton>×</span>
                  </div>
                  <div className="col-md-6">
                    <div className="modal-left-side">
                      <div className="moda-left-heading">
                        <h2>{quickView && quickView.title}</h2>
                      </div>
                      <div className="modal-seemore">
                        See More from{" "}
                        <a href="#">{this.state.brand && this.state.brand}</a>
                        Shop
                      </div>
                      <div className="modal-reviews">
                        <ul id="modal-stars">
                          <StarRatings
                            rating={
                              quickView && quickView.reviews
                                ? quickView.reviews / quickView.reviewCount
                                : 0
                            }
                            starDimension="20px"
                            starSpacing="2px"
                            starRatedColor="gold"
                          />
                          <span>{quickView && quickView.reviewCount}</span>
                        </ul>
                      </div>
                      <div className="modal-slider">
                        <CarouselProvider
                          visibleSlides={1}
                          totalSlides={quickView && quickView.images.length}
                          step={1}
                          naturalSlideWidth={400}
                          naturalSlideHeight={400}
                          hasMasterSpinner
                        >
                          <Slider>
                            {quickView &&
                              quickView.images &&
                              quickView.images.map((item, index) => (
                                <Slide index={index}>
                                  <ImageWithZoom src={item} />
                                </Slide>
                              ))}
                          </Slider>

                          <DotGroup />
                        </CarouselProvider>
                      </div>
                    </div>{" "}
                    {/*END MODAL LEFT SIDE*/}
                  </div>
                  <div
                    className="col-md-6"
                    style={{ backgroundColor: "hsla(240,5%,96%,.85)" }}
                  >
                    <div className="moda-right-side">
                      <div className="modal-right-price">
                        <span className="m-price">
                          $
                          {quickView.enableSale === true
                            ? Number(
                                quickView.price -
                                  (quickView.price * quickView.saleDiscount) /
                                    100
                              ).toFixed(2) * this.state.quantity
                            : Number(quickView.price).toFixed(2) *
                              this.state.quantity}
                        </span>
                        <span>
                          {quickView.enableSale === true ? (
                            <del className="moda-right-price-off">
                              ${Number(quickView.price).toFixed(2)}
                            </del>
                          ) : null}
                        </span>
                      </div>
                      <div className="modal-shiping-dete">
                        <span>FREE Shipping</span>
                        <span>Get it Now</span>
                      </div>

                      <div className="modal-right-collapse">
                        <div className="accordion" id="accordion">
                          <div className="card mt-3">
                            <div className="checkout-inps">
                              <span className="selectcountry-hint">
                                Select Quantity
                              </span>
                              <select
                                className="countrySelect"
                                onChange={(e) => {
                                  this.setState({
                                    quantity: e.target.value,
                                  });
                                }}
                              >
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                              </select>
                            </div>
                          </div>
                          <div className="card mt-3">
                            <div
                              id="product-description"
                              className="collapse-heading"
                            >
                              <button
                                className="btn btn-link collapsed py-md-3"
                                type="button"
                                data-toggle="collapse"
                                data-target="#description-collapse"
                                aria-expanded="false"
                                aria-controls="description-collapse"
                              >
                                Description
                                <span>
                                  <i className="fa fa-angle-down" />
                                </span>
                              </button>
                            </div>
                            <div
                              id="description-collapse"
                              className="collapse"
                              aria-labelledby="product1description"
                              data-parent="#accordion"
                            >
                              <div className="card-body">
                                <div className="description-body">
                                  <div className="description-content">
                                    <p>{quickView && quickView.description}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card mt-3">
                            <div
                              id="product-weights-dimention"
                              className="collapse-heading"
                            >
                              <button
                                className="btn btn-link collapsed py-md-3"
                                type="button"
                                data-toggle="collapse"
                                data-target="#weights-dimention-collapse"
                                aria-expanded="false"
                                aria-controls="weights-dimention-collapse"
                              >
                                Weights & Dimensions
                                <span>
                                  <i className="fa fa-angle-down" />
                                </span>
                              </button>
                            </div>
                            <div
                              id="weights-dimention-collapse"
                              className="collapse"
                              aria-labelledby="product1weights-dimention"
                              data-parent="#accordion"
                            >
                              <div className="card-body">
                                <div className="weights-dimension-content">
                                  {quickView &&
                                    quickView.weightAndDimension &&
                                    quickView.weightAndDimension.weightAndDimension.map(
                                      (e, index) => (
                                        <Fragment key={index}>
                                          {JSON.parse(e).value &&
                                          JSON.parse(e).value !== "" ? (
                                            <Fragment>
                                              <p className="dimension-heading">
                                                {JSON.parse(e).name}
                                              </p>
                                              <div className="product-weight">
                                                <div className="overall-weight">
                                                  <p className="m-0 py-2">
                                                    {JSON.parse(e).name}
                                                  </p>
                                                </div>
                                                <p className="m-0 py-2">
                                                  {JSON.parse(e).value}
                                                </p>
                                              </div>
                                            </Fragment>
                                          ) : null}
                                        </Fragment>
                                      )
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card mt-3">
                            <div
                              id="product-spesification"
                              className="collapse-heading"
                            >
                              <button
                                className="btn btn-link collapsed py-md-3"
                                type="button"
                                data-toggle="collapse"
                                data-target="#spesification-collapse"
                                aria-expanded="false"
                                aria-controls="spesification-collapse"
                              >
                                Specifications
                                <span>
                                  <i className="fa fa-angle-down" />
                                </span>
                              </button>
                            </div>
                            <div
                              id="spesification-collapse"
                              className="collapse"
                              aria-labelledby="product1spesification"
                              data-parent="#accordion"
                            >
                              <div className="card-body">
                                <div className="spesification-content">
                                  {quickView &&
                                    quickView.specification &&
                                    quickView.specification.specification.map(
                                      (e, index) => (
                                        <div
                                          key={index}
                                          className="product-weight"
                                        >
                                          {" "}
                                          {JSON.parse(e).value &&
                                          JSON.parse(e).value !== "" ? (
                                            <Fragment>
                                              <div className="overall-weight">
                                                <p className="m-0 py-2">
                                                  {JSON.parse(e).name}
                                                </p>
                                              </div>
                                              <p className="m-0 py-2">
                                                {JSON.parse(e).value}
                                              </p>
                                            </Fragment>
                                          ) : null}
                                        </div>
                                      )
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="modal-end-btns">
                            <button
                              type="button"
                              className="modal-add-cart"
                              onClick={(e) => {
                                e.preventDefault();
                                this._addToCart(quickView && quickView);
                              }}
                            >
                              <span>Add To Cart</span>
                            </button>
                            <button
                              type="button"
                              className="modal-save-btn"
                              onClick={(e) => {
                                e.preventDefault();
                                this._addToWishlist(quickView && quickView);
                              }}
                            >
                              <span>
                                <i className="far fa-heart" /> Save
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              "<div></div>"
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}

getProducts.propTypes = {
  getProducts: PropTypes.func.isRequired,
};
getProductsByCategoryId.propTypes = {
  getProductsByCategoryId: PropTypes.func.isRequired,
};
subCategories.propTypes = {
  subCategories: PropTypes.func.isRequired,
};
childCategories.propTypes = {
  childCategories: PropTypes.func.isRequired,
};
cartAdd.propTypes = {
  cartAdd: PropTypes.func.isRequired,
};
getSubCategoryBySlug.propTypes = {
  getSubCategoryBySlug: PropTypes.func.isRequired,
};

getGroups.propTypes = {
  getGroups: PropTypes.func.isRequired,
};
getFilteredProduct.propTypes = {
  getFilteredProduct: PropTypes.func.isRequired,
};

export default withRouter(
  connect(null, {
    childCategories,
    subCategories,
    getProducts,
    cartAdd,
    getProductsByCategoryId,
    getSubCategoryBySlug,
    getGroups,
    getFilteredProduct,
  })(Index)
);
